import { createSlice } from "@reduxjs/toolkit";
import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";

const messageBoxState = {
  inboxUI: null,
  memberInboxList: null,
  inboxDetail: null,
  error: null,
  listLoading: false,
  actionsLoading: false,
  searchLoading: false,
  isRefresh: false,
};

export const messageBoxSlice = createSlice({
  name: "messageBox",
  initialState: messageBoxState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = false;
      }
    },
    throwError: (state, action) => {
      state.error = action.payload.data.error;
    },
    startCall: (state, action) => {
      state.isRefresh = false;
      state.error = null;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = true;
      }
    },
    clearError: (state) => {
      state.error = null;
    },
    memberInboxListFetched: (state, action) => {
      state.listLoading = false;
      state.memberInboxList = action.payload.data ?? {};
    },
    inboxUIFetched: (state, action) => {
      state.actionsLoading = false;
      state.inboxUI = action.payload.data ?? {};
    },
    inboxDetailFetched: (state, action) => {
      state.actionsLoading = false;
      state.inboxDetail = action.payload.data ?? {};
    },
    moreInboxDetailFetched: (state, action) => {
      state.listLoading = false;
      state.inboxDetail = {
        ...state.inboxDetail,
        ...(action.payload.data ?? {}),
        inboxDetails: [
          ...state.inboxDetail.inboxDetails,
          ...(action.payload.data?.inboxDetails ?? []),
        ],
      };
    },
    clearInboxDetail: (state, action) => {
      state.inboxDetail = null;
    },
    postManaged: (state, action) => {
      state.actionsLoading = false;
    },
  },
});
